export const SESSION_STORAGE_KEY = 'transfer-share-savings-account-form-storage';
export const readFormSessionStorage = () => {
    try {
        const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    }
    catch {
        return {};
    }
};
export const writeFormSessionStorage = (context) => {
    try {
        sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(context));
    }
    catch {
        // sessionStorage unavailable POC, ignore
    }
};
export const updateFormSessionStorage = (partial) => {
    const current = readFormSessionStorage();
    const updated = { ...current, ...partial };
    writeFormSessionStorage(updated);
    return updated;
};
export const clearFormSessionStorage = () => {
    try {
        sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
    catch {
        // ignore
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1zZXNzaW9uLXN0b3JhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvYXBwcy90cmFuc2Zlci1zaGFyZS1zYXZpbmdzLWFjY291bnQvdXRpbHMvZm9ybS1zZXNzaW9uLXN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUcsNkNBQTZDLENBQUM7QUFFakYsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQUcsR0FBZ0IsRUFBRTtJQUNwRCxJQUFJLENBQUM7UUFDRCxNQUFNLEdBQUcsR0FBRyxjQUFjLENBQUMsT0FBTyxDQUFDLG1CQUFtQixDQUFDLENBQUM7UUFDeEQsT0FBTyxHQUFHLENBQUMsQ0FBQyxDQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFpQixDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUM7SUFDdkQsQ0FBQztJQUFDLE1BQU0sQ0FBQztRQUNMLE9BQU8sRUFBRSxDQUFDO0lBQ2QsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLENBQUMsT0FBb0IsRUFBUSxFQUFFO0lBQ2xFLElBQUksQ0FBQztRQUNELGNBQWMsQ0FBQyxPQUFPLENBQUMsbUJBQW1CLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0lBQ3pFLENBQUM7SUFBQyxNQUFNLENBQUM7UUFDTCx5Q0FBeUM7SUFDN0MsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLHdCQUF3QixHQUFHLENBQUMsT0FBNkIsRUFBZSxFQUFFO0lBQ25GLE1BQU0sT0FBTyxHQUFHLHNCQUFzQixFQUFFLENBQUM7SUFDekMsTUFBTSxPQUFPLEdBQUcsRUFBRSxHQUFHLE9BQU8sRUFBRSxHQUFHLE9BQU8sRUFBRSxDQUFDO0lBQzNDLHVCQUF1QixDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ2pDLE9BQU8sT0FBTyxDQUFDO0FBQ25CLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLEdBQVMsRUFBRTtJQUM5QyxJQUFJLENBQUM7UUFDRCxjQUFjLENBQUMsVUFBVSxDQUFDLG1CQUFtQixDQUFDLENBQUM7SUFDbkQsQ0FBQztJQUFDLE1BQU0sQ0FBQztRQUNMLFNBQVM7SUFDYixDQUFDO0FBQ0wsQ0FBQyxDQUFDIn0=